export default __webpack_public_path__ + "static/media/chat-primary.c2b0aa8d.svg";